import { Practitioner } from './practitioner.model';
import { ConversionHelper } from '../helpers/conversion-helper';

export class SearchResult {
  practitioner: Practitioner;
  distance: number;
  matches: string[];

  constructor(practitioner: Practitioner, distance: number, matches: string[]) {
    this.practitioner = practitioner;
    this.distance = distance;
    this.matches = matches;
  }

  getDistance(inMiles: boolean): string {
    if (inMiles) {
      return ConversionHelper.convertMetersToMiles(this.distance) + 'mi';
    }
    return ConversionHelper.convertMetersToKilometers(this.distance) + 'km';
  }

  static mapSearchResult(result: any, id: string): SearchResult {
    var matchedTerms: string[] = [];
    for (let key of Object.keys(result._highlightResult)) {
      this._checkMatchLevel(result._highlightResult[key], matchedTerms);
    }

    let resultDistance: number = result._rankingInfo.geoDistance;
    return new SearchResult(
      Practitioner.mapFromFirestore(result, id),
      resultDistance,
      Array.from(new Set(matchedTerms))
    );
  }

  static _checkMatchLevel(path: any, matchedTerms: string[]): string[] {
    if (path.matchLevel && path.matchLevel !== 'none') {
      path.matchedWords.forEach(term => {
        matchedTerms.push(term);
      });
      return matchedTerms;
    }

    if (!path.matchLevel) {
      for (let key of Object.keys(path)) {
        this._checkMatchLevel(path[key], matchedTerms);
      }
    }

    return matchedTerms;
  }
}
